<template>
    <div class="itemgroup-list">
        <v-card>
            <v-card-title style="background-color: rgb(33, 57, 141); color: white;">
                {{$t('productGroup.productGroup')}}
                <v-spacer></v-spacer>
                <v-btn dark icon :to="{name: 'itemgroup-detail'}"><v-icon>add</v-icon></v-btn>
            </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="loadAll"
                        class="elevation-1"
                        :pagination.sync="pagination"
                >
                    <template slot="headerCell" slot-scope="props">
                        {{$t(props.header.text)}}
                    </template>
                    <template v-slot:items="props">
                        <td>{{ props.item.attributes.title }}</td>
                        <td class="text-sm-right">
                            <v-btn icon :to="{ name: 'itemgroup-detail', params: { id: props.item.id }}"><v-icon color="primary">edit</v-icon></v-btn>
                            <v-btn icon @click="deletePost(props.item);"><v-icon color="primary">delete</v-icon></v-btn>
                        </td>
                    </template>
                </v-data-table>
        </v-card>
    </div>
</template>

<script  >
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {
            this.loadAllPosts();
        },
        methods: {
            ...mapActions({
                loadAllPosts: 'productCategories/loadAll',
                deletePost: 'productCategories/delete',
            }),
        },
        computed: {
            ...mapGetters({
                loading: "productCategories/isLoading",
                error: "productCategories/isError",
                loadAll: "productCategories/all",
            }),
        },
        data() {
            return {
                title: "",
                headers: [
                    {text: "productGroup.title", value: "attributes.title"},
                    {text: "", value: "actions"}
                ],
                pagination: {
                    rowsPerPage: 10,
                },
            };
        },
    };
</script>
